import {Header, Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';
import LimitStatusNote from '@/screens/Merchants/common/LimitStatusNote';

import BusinessLimitsFilters from './BusinessLimitsFilters';
import BusinessLimitsTable from './BusinessLimitsTable';
import useLimitList from './useLimitList';

const LimitList = () => {
  const {
    isLoading,
    fetchList,
    pageInfo,
    list,
    isPageReset,
    isSearch,
    selectCurrentFilters,
    currentFilters,
    handleAutoComplete,
    clearFilters,
  } = useLimitList();

  return (
    <main className="my-5 mx-4 md:mx-10">
      <Header title="Merchant Limits" dataCy="merchant-limits-title" />
      <LimitStatusNote inUse>
        General limit rules, which can target a business, currency, country,
        channel, processor, wallet or transaction type. Max is the most a
        business can transact under a rule, in USD for amount rules. A once max
        applies to a single transaction; the daily, weekly and monthly totals
        reset at 00:00 UTC (the week resets on Monday, the month on the 1st).
        Min is the smallest single transaction an amount rule allows.
      </LimitStatusNote>
      <BusinessLimitsFilters
        dataCy="merchant-limits"
        handleAutoComplete={handleAutoComplete}
        currentFilters={currentFilters}
        selectCurrentFilters={selectCurrentFilters}
        clearFilters={clearFilters}
      />

      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <BusinessLimitsTable items={list} dataCy="merchant-limits" />
        )}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default LimitList;
